module.exports = __webpack_public_path__ + "img/gPay-Invite.6a46fe37.svg";